<template>
  <div class="view">
    <GridPanelHeader
      :title="$t('products_catalog.fito_products.title')"
      :grid-ref="$refs.FitoProductsGrid"
      :show-add="false"
      :show-filter="false"
      :show-columns="false"
      :show-export="false"
    />
    <DxDataGrid
      key-expr="uuid"
      :ref="gridRefKey"
      :data-source="FitoProductsDataSurce"
      :remote-operations="gridRemoteOperations"
      :column-min-width="80"
      :show-column-lines="true"
      :show-row-lines="false"
      :show-borders="true"
      :showBorders="true"
      :column-auto-width="true"
      :allowColumnReordering="true"
      :allowColumnResizing="true"
      :row-alternation-enabled="true"
      :searchPanel="{ visible: false, width: 240, placeholder: 'Search...' }"
      :element-attr="gridAttributes"
      :row-height="50"
    >
      <DxColumn
        dataField="product_name"
        :caption="$t('common.name')"
        :allowHeaderFiltering="true"
        :filter-operations="['contains']"
        :allowSorting="true"
      ></DxColumn>
      <DxColumn
        dataField="state.name"
        :caption="$t('common.status')"
        :allowHeaderFiltering="true"
        :filter-operations="['contains']"
        :allowSorting="true"
        :width="150"
      ></DxColumn>
      <DxColumn
        dataField="category.name"
        :caption="$t('products_catalog.fito_products.category')"
        :allowHeaderFiltering="true"
        :filter-operations="['contains']"
        :allowSorting="true"
        :width="150"
      ></DxColumn>
      <DxColumn
        dataField="class.name"
        :caption="$t('products_catalog.fito_products.classe')"
        :allowHeaderFiltering="true"
        :filter-operations="['contains']"
        :allowSorting="true"
      ></DxColumn>
      <DxColumn
        dataField="ingredient_name"
        :caption="$t('products_catalog.fito_products.ingredient')"
        :allowHeaderFiltering="true"
        :filter-operations="['contains']"
        :allowSorting="true"
      ></DxColumn>
      <DxColumn
        dataField="measure_unit_name"
        :caption="$t('products_catalog.fito_products.measure_unit')"
        :allowHeaderFiltering="true"
        :filter-operations="['contains']"
        :allowSorting="true"
      ></DxColumn>
      <DxColumn
        dataField="quantity"
        :caption="$t('common.quantity')"
        :allowHeaderFiltering="true"
        :filter-operations="['=', '<', '>']"
        :allowSorting="true"
      ></DxColumn>
      <DxColumn
        dataField="culture_name"
        :caption="$t('common.culture')"
        :allowHeaderFiltering="true"
        :filter-operations="['contains']"
        :allowSorting="true"
      ></DxColumn>
      <DxColumn
        dataField="disease_type"
        :caption="$t('products_catalog.fito_products.disease_type')"
        :allowHeaderFiltering="true"
        :filter-operations="['contains']"
        :allowSorting="true"
      ></DxColumn>
      <DxColumn
        dataField="disease_name"
        :caption="$t('products_catalog.fito_products.disease_name')"
        :allowHeaderFiltering="true"
        :filter-operations="['contains']"
        :allowSorting="true"
      ></DxColumn>
      <DxColumn
        dataField="dose_min"
        :caption="$t('products_catalog.fito_products.dose_min')"
        :allowHeaderFiltering="true"
        :filter-operations="['=', '<', '>']"
        :allowSorting="true"
      ></DxColumn>
      <DxColumn
        dataField="dose_max"
        :caption="$t('products_catalog.fito_products.dose_max')"
        :allowHeaderFiltering="true"
        :filter-operations="['=', '<', '>']"
        :allowSorting="true"
      ></DxColumn>
      <DxColumn
        dataField="dose_unit"
        :caption="$t('products_catalog.fito_products.dose_unit')"
        :allowHeaderFiltering="true"
        :filter-operations="['contains']"
        :allowSorting="true"
      ></DxColumn>
      <DxColumn
        dataField="dose_note"
        :caption="$t('products_catalog.fito_products.dose_note')"
        :allowHeaderFiltering="true"
        :filter-operations="['contains']"
        :allowSorting="true"
      ></DxColumn>
      <DxColumn
        dataField="expiration_date"
        :caption="$t('products_catalog.fito_products.certificate_expiration')"
        :allowHeaderFiltering="true"
        :filter-operations="['contains']"
        :allowSorting="true"
      ></DxColumn>
      <DxColumn
        dataField="authorization_holder"
        :caption="$t('products_catalog.fito_products.authorization_holder')"
        :allowHeaderFiltering="true"
        :filter-operations="['contains']"
        :allowSorting="true"
      ></DxColumn>

      <DxPaging :total="3500" :page-size="15" />
      <DxPager
        :visible="true"
        :allowed-page-sizes="pageSizes"
        display-mode="compact"
        :show-page-size-selector="true"
        :show-info="true"
        :show-navigation-buttons="true"
        :info-text="$t('common.page_info')"
      />
      <DxHeaderFilter :visible="false" />
      <DxFilterRow :visible="true" :showOperationChooser="true" apply-filter="auto" />
    </DxDataGrid>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import DxDataGrid, {
  DxColumn,
  DxPaging,
  DxPager,
  DxEditing,
  DxHeaderFilter,
  DxFilterRow,
  DxSelection,
  DxTexts,
  DxButton,
  DxPopup,
  DxToolbar,
  DxItem,
  DxSearchPanel,
  DxExport,
  DxGroupPanel,
  DxColumnChooser,
  DxColumnFixing,
  DxLookup,
} from "devextreme-vue/data-grid";
import DxSelectBox from "devextreme-vue/select-box";
import DxTagBox from "devextreme-vue/tag-box";
import Forbidden from "~/pages/errors/Forbidden.vue";
import CustomStore from "devextreme/data/custom_store";
import { canView, canDelete, canEdit, permissions, permissionTypes } from "~/helpers/Permissions";
import GridPanelHeader from "@/components/DxGrid/GridPanelHeader.vue";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxHeaderFilter,
    DxFilterRow,
    DxSelection,
    DxTexts,
    DxButton,
    DxPaging,
    DxPager,
    DxPopup,
    DxToolbar,
    DxItem,
    Forbidden,
    DxSearchPanel,
    DxTagBox,
    DxExport,
    DxGroupPanel,
    DxColumnChooser,
    DxColumnFixing,
    DxSelectBox,
    DxLookup,
    GridPanelHeader,
  },
  data() {
    return {
      localWeighingTypes: [],
      gridAttributes: {
        class: "smagria-grid fito-products-grid",
      },
      gridRefKey: "FitoProductsGrid",
      FitoProductsDataSurce: new CustomStore({
        key: "uuid",
        load: async (loadOptions) => {
          let dataSource = {
            data: [],
            totalCount: 0,
          };

          let pageLimit = loadOptions.take;
          let pageNumber = (loadOptions.skip + loadOptions.take) / pageLimit;

          let payload = {
            page: pageNumber,
            limit: pageLimit,
            filter: loadOptions.filter,
            sort: loadOptions.sort,
          };

          try {
            await this.getFitoProductList(payload).then((response) => {
              dataSource.data = response.data.data;
              dataSource.totalCount = response.data?.pagination?.total ?? 1;
            });

            return dataSource;

            // await this.getFitoProductList(payload);
            //
            // return dataSource;
          } catch (error) {
            console.error("Error fetching products:", error);
            throw error;
          }
        },
      }),
      gridRemoteOperations: {
        paging: true,
        filtering: true,
        sorting: true,
      },
      pageSizes: [15, 25, 100],
      editingRowData: null,
      yes_no_list: [
        {
          id: 1,
          label: this.$t("common.yes"),
        },
        {
          id: 0,
          label: this.$t("common.no"),
        },
      ],
      visibilitySettingsLoaded: false,
      visibilitySettingsLoading: false,
      saveColumnSettingsTimeout: null,
    };
  },
  computed: {
    config() {
      return {
        permission: permissions.PRODUCT_CATALOG,
        permission_type: permissionTypes.access,
      };
    },
    canView() {
      return canView(this);
    },
    canEdit() {
      return canEdit(this);
    },
    canDelete() {
      return canDelete(this);
    },
    dataGridInstance: function () {
      return this.$refs[this.gridRefKey].instance;
    },
  },
  methods: {
    ...mapActions({
      getFitoProductList: "productCatalog/getFitoProductList",
      //getFitoProduct: "fitoProduct/getFitoProducts",
      getDxGridSettings: "dxgrid/getDxGridSettings",
      setDxGridSettings: "dxgrid/setDxGridSettings",
    }),
  },
};
</script>
